import {
  BISAC_HEADING_SEPARATOR,
  SUBJECT_PREFIX_LENGTH,
} from "components/BisacCodes/bisacSubjects";
import type { FacetResult } from "hooks/search/types";

export type BisacFacetItem = FacetResult["counts"][number];

export interface BisacFilterSubject {
  code: string;
  label: string;
  items: BisacFacetItem[];
}

export const sortBisacItems = (items: BisacFacetItem[]): BisacFacetItem[] =>
  [...items].sort(
    (a, b) =>
      (a.seq ?? Infinity) - (b.seq ?? Infinity) ||
      a.value.localeCompare(b.value),
  );

const getSubjectCode = (item: BisacFacetItem) =>
  item.subjectCode ?? item.value.slice(0, SUBJECT_PREFIX_LENGTH);

export const getBisacSubjectLabel = (item: BisacFacetItem) =>
  item.subjectLabel ?? getSubjectCode(item);

export const groupBisacFacetItems = (
  items: BisacFacetItem[],
): BisacFilterSubject[] => {
  const subjects = new Map<string, BisacFilterSubject>();

  for (const item of items) {
    const code = getSubjectCode(item);
    const subject = subjects.get(code) ?? {
      code,
      label: getBisacSubjectLabel(item),
      items: [],
    };
    subject.items.push(item);
    subjects.set(code, subject);
  }

  return [...subjects.values()];
};

export const stripSubjectHeading = (
  item: BisacFacetItem,
  subjectLabel: string,
): string => {
  const label = item.label ?? "";
  const subjectPrefix = `${subjectLabel}${BISAC_HEADING_SEPARATOR}`;

  return label.startsWith(subjectPrefix)
    ? label.slice(subjectPrefix.length)
    : label;
};
